module.exports = __webpack_public_path__ + "img/mythic.674dbc7f.png";